<template>
	<div class="addPerson tableSys mb05x" id="subordinateSystem">
		<div class="posR drop-list-box" @mouseenter="clearfixCloseDropTimer" @mouseleave="closeDrop">
			<InputText :placeholder="placeholderText" v-model="subSysName" @Keyup="getListByKey" @mouseenter.native="getStructure" :readonly="readonly" name="subSysName"></InputText>
			<div class="drop-list clearfix" v-show="flag" scroll>
				<div>
					<v-tree ref="tree" :data='treeData' v-show="treeData.length" :multiple='false' :halfcheck="false" @node-click="nodeClick"/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters,mapActions } from 'vuex'
import * as lib from "@/util/lib"
import {getLanguageStr} from "@/util/language"

import InputText from "@/components/common/ui/InputText"
import VTree from '@/components/common/ui/vTree/Tree'
import Loading from '@/components/common/ui/Loading'
import TagBox from "@/components/common/ui/TagBox"

import * as tree from '@/util/vTree'
import * as groupMemberApi from '@/api/manage/groupMember'
import * as maintainApi from '@/api/maintain/plant/list'
import {changeTreeDataToList} from '@/util/projectTree'

let timer = null
let closeDropTimer = null
const length = 50
export default {
	name:'SubordinateSystem',
	components:{
		InputText,
		VTree,
		Loading,
		TagBox
	},
	props: {
		stationId:{
			type:[Number,String]
		},
		title:{
			type:String,
			default:getLanguageStr('word1336','成员')
		},
		maxSelect:{
			type:Array,	//[n,"language的填充key"] [1]可为空，则默认fill3rd75 选择的数量不能超过{0}
			default:function(){return new Array();}
		}
	},
	data(){
		return {
			flag:false,
			node:{},
			treeData: [],
			requestData:{},
			currentGroup:{},
			placeholderText:getLanguageStr('plant317','请选择设备所属系统'),
			maxSelectTip:"",
			readonly: true,
			subSysName:'',
			subSysId:'',
		}
	},
	created() {
		// this.getStructure()
	},
	methods:{
		getLanguageStr,
		clearfixCloseDropTimer(){
			if(closeDropTimer) clearTimeout(closeDropTimer);	//enter时如已离开过，清除timer
		},
		getStructure(){
			this.flag = true;
		},
		init(stationId,systemId){	//打开下拉时执行，输入搜索时直接执行getListByKey
		// console.log(stationId)
		// console.log(systemId)
			if (!this.flag) {	//只有flag==flase的情况下查询
				maintainApi.StationStructure(stationId).then(res=>{
					this.treeDataArr = changeTreeDataToList([res]) //把返回值换成扁平结构后重新组装（目的：返回之中children字段会有null,去除null）
					if(stationId==systemId){
						this.treeDataArr.forEach((data,index) => {
							if(data.id == stationId) {
								this.$set(data,'selected',true);
								this.subSysName = data.name;
								this.subSysId=data.id;
							} else {
								this.$set(data,'selected',false);
							}
							this.$set(data,'expanded',true)
							this.$set(data,'title', `${data.name}(${data.deviceNum}${getLanguageStr('word164','设备')})`)
						})
						this.$emit('Update',stationId)
					}else{
						this.treeDataArr.forEach((data,index) => {
							if(data.id == systemId) {
								this.$set(data,'selected',true);
								this.subSysName = data.name;
								this.subSysId=data.id;
							} else {
								this.$set(data,'selected',false);
							}
							this.$set(data,'expanded',true)
							this.$set(data,'title', `${data.name}(${data.deviceNum}${getLanguageStr('word164','设备')})`)
						})
						this.$emit('Update',systemId)
					}
	                let arr = tree.toTree(this.treeDataArr)
	                this.treeData  = _.cloneDeep(arr);
	              
				},error=>{
	                this.$refs.Loading.hide()
					!_.isEmpty(error) && this.$notify(error)
				});
				
			}
		},
		closeDrop(){
			let $this=this;
			closeDropTimer = setTimeout(function(){
				$this.flag = false;
			},500)
		},
		nodeClick(node){
			this.subSysName=node.name
			this.flag=false
			this.$emit('Update',node.id)
		},
		getListByKey() {
			if (this.currentGroup.id && this.flag) {	//已有分组信息且显示下拉时
				if(timer) clearTimeout(timer)
				timer = setTimeout(() => {
					this.requestData = {
						"page": 1,
						"size": 10000,
						"order.direction": "DESC",
						"order.property": "id",
						"selectGroupId": this.currentGroup.id,
						"markName": this.searchKey
					}
					this.requestData={...this.requestData,markName:this.searchKey}
					this.getUserList(this.requestData)
				}, 50);
			}
		},
	},
	computed: {
	},
	watch:{
	},
	mounted() {
		lib.setScroll($("#subordinateSystem [scroll]"))
	}
}
</script>
<style lang="scss" scoped>
.drop-list{

	background: #fff;
	z-index:1000;
	width:100%;
	max-height:10em;
	overflow: hidden;
	border-bottom-left-radius: 2px;
	border-bottom-right-radius: 2px;
	border:1px solid rgba(0,0,0,.1);
	border-top:none;
	.l{
		width:70%;height: 100%;border-right:1px solid rgba(0,0,0,.1);float:left;
	}
	.r{
		width:30%;height: 100%;float:left;
		li{
			list-style-type: none;
			line-height: 2em;
			height:2em;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
			padding-left: .5em;
		}
	}
	.no-data{
		height:100%;text-align:center;line-height:20em;
	}
}
.tpl{
	display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/part/childSys/SubordinateSystem.vue